<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-container :class="`text-${$vuetify.breakpoint.name}-h6`" :style="styleObject()" class="text-uppercase ma-0 pa-0 mw-100">{{ text }}</v-container>
  </v-container>
</template>
<script>
export default {
  name: 'HeaderSmall',
  props: {
    text: String,
  },
  methods: {
    styleObject() {
      return {
        color: this.$vuetify.theme.themes.light.primary
      };
    },
  },
};
</script>
